import { Button } from "@mui/material";

interface Props {
  openWhatsCoveredModal(state: boolean): void;
}

export function WhatsCoveredButton({ openWhatsCoveredModal }: Props) {
  return (
    <Button
      onClick={() => openWhatsCoveredModal(true)}
      data-testid="compare-plans-button"
      size="small"
      variant="outlined"
      fullWidth>
      What&apos;s Covered?
    </Button>
  );
}
